export const LlmIntegrationProviders = () => {
  const providers = [
    { name: "OpenAI", models: "GPT-4o, GPT-4, GPT-3.5", strength: "Best overall quality", pricing: "$5-60/1M tokens" },
    { name: "Anthropic", models: "Claude 3.5 Sonnet, Opus", strength: "Long context, safety", pricing: "$3-75/1M tokens" },
    { name: "Google", models: "Gemini Pro, Flash", strength: "Multimodal, speed", pricing: "Free tier + paid" },
    { name: "Open Source", models: "Llama 3, Mixtral", strength: "Privacy, cost control", pricing: "Self-hosted" },
  ];
  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">Provider Comparison</h2>
      <div className="grid md:grid-cols-2 gap-4">
        {providers.map((p, i) => (
          <div key={i} className="bg-card rounded-xl border border-border p-5">
            <h3 className="font-semibold text-foreground mb-2">{p.name}</h3>
            <p className="text-sm text-muted-foreground mb-1"><strong>Models:</strong> {p.models}</p>
            <p className="text-sm text-muted-foreground mb-1"><strong>Strength:</strong> {p.strength}</p>
            <p className="text-sm text-primary"><strong>Pricing:</strong> {p.pricing}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
